import { InputSearchIcon } from "../../../assets/icons/icon";
import { sentenceCase } from "../../../constants";
import { AppCheckbox } from "../../../Libraries";
import UBInput from "../../../Libraries/UBInput";
import styles from "./styles.module.css";

/**
 * Category filter: search input + multi-select checkbox list.
 */
const CategoryFilterContent = ({
  options = [],
  selectedSet = new Set(),
  searchQuery = "",
  onSearchChange,
  onToggleOption,
  searchPlaceholder = "Search",
}) => {
  const filtered = !searchQuery.trim()
    ? options
    : options.filter((o) =>
        o.label.toLowerCase().includes(searchQuery.toLowerCase()),
      );

  return (
    <div className={styles.popoverContent}>
      <div className={styles.searchWrapper}>
        <UBInput
          inputId="category_filter_search"
          name="search"
          label=""
          value={searchQuery}
          placeholder={searchPlaceholder}
          onChange={(name, text) => onSearchChange?.(text)}
          inputClassname={styles.searchInput}
          baseClassname={styles.searchInputBase}
          prefix={<InputSearchIcon />}
        />
      </div>
      <ul className={styles.checkboxList}>
        {filtered.map((opt) => (
          <li
            key={opt.value}
            role="option"
            aria-selected={selectedSet.has(opt.value)}
            className={`${styles.checkboxItem} ${styles.checkboxItemAppCheckbox}`}
            onClick={() => onToggleOption?.(opt.value)}
          >
            <AppCheckbox
              checked={selectedSet.has(opt.value)}
              label={sentenceCase(opt.label)}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CategoryFilterContent;
